<template>
  <div>
    <!-- <van-nav-bar
      @click-left="clickBack"
      title="代接送详情"
      left-arrow
      v-if="mode != 'notice'"
    /> -->
    <!-- <div class="card" v-if="type == 'au'">
      <div class="title">{{ query.leaveName }}提交的请假申请</div>
      <div class="panel flex flex-vc border-b">
        <div class="info">
          <div class="name">{{ query.leaveName }}</div>
          <div class="phone">共计{{ query.du }}</div>
        </div>
      </div>
    </div> -->
    <div class="detail">
      <div class="card">
        <div class="cell">
          <span class="headline">家长姓名</span>
          <span>{{ data.patriarchName }}</span>
        </div>
        <div class="title border-b">孩子信息</div>

        <div
          class="panel flex flex-vc border-b"
          v-for="item in data.childMessage"
          :key="item.id"
        >
          <img :src="item.avatar" alt="" @click="previewImg(item.avatar)" />
          <div class="info">
            <div class="name">{{ item.name }}</div>
            <div class="phone">{{ item.className }}</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="title border-b">代接送人信息</div>
        <div class="panel flex flex-vc border-b">
          <img
            :src="data.pickUpPhoto"
            alt=""
            @click="previewImg(data.pickUpPhoto)"
          />
          <div class="info">
            <div class="name">{{ data.pickUpPerson }}</div>
            <div class="phone">
              <span @click.stop="getTeacherOrParentMobile(data, data.isShowMobile)">{{ data.isShowMobile ? data.noMobile : data.pickUpPhone }}</span>
              <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click.stop="getTeacherOrParentMobile(data, data.isShowMobile)" v-if="!data.isShowMobile" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click.stop="getTeacherOrParentMobile(data, data.isShowMobile)" v-if="data.isShowMobile"
                  name="closed-eye" />
            </div>
          </div>
        </div>

        <div class="cell">
          <span class="headline">审批状态</span>
          <van-tag
            plain
            type="success"
            size="medium"
            v-if="data.pickUpState == 1"
            >已同意</van-tag
          >
          <van-tag
            plain
            type="primary"
            size="medium"
            v-if="data.pickUpState == 0"
            >待审批</van-tag
          >
          <van-tag
            plain
            type="danger"
            size="medium"
            v-if="data.pickUpState == -1"
            >已拒绝</van-tag
          >
          <van-tag
            plain
            type="danger"
            size="medium"
            v-if="data.pickUpState == -2"
            >已过期</van-tag
          >
        </div>
        <div class="cell">
          <span class="headline">开始时间</span>
          <span>{{ getDateYMD(data.pickUpBeginTime) }}</span>
        </div>
        <div class="cell">
          <span class="headline">结束时间</span>
          <span>{{ getDateYMD(data.pickUpEndTime) }}</span>
        </div>
        <div class="cell">
          <span class="headline">原因</span>
          <span style="flex: 1">{{ data.reason }}</span>
        </div>
      </div>

      <!-- <div class="card">
      <div class="title">
        审批状态
      </div>
      <div class="panel">
        <van-steps direction="vertical" :active="2" active-color="#1989fa">
          <van-step v-for="item in auditList">
            <div>
              <span style="margin-right: 0.5rem;">{{ item.auditName }}</span>
              <van-tag
                plain
                type="success"
                size="medium"
                v-if="item.auditState == 1"
                >已同意</van-tag
              >
              <van-tag
                plain
                type="primary"
                size="medium"
                v-if="item.auditState == 0"
                >待审批</van-tag
              >
              <van-tag
                plain
                type="danger"
                size="medium"
                v-if="item.auditState == -1"
                >已拒绝</van-tag
              >
            </div>
            <div v-if="item.auditTime" style="color: #999; margin-top: 0.5rem;">
              <span>时间：</span>{{ getDateYMD(item.auditTime) }}
            </div>
            <div v-if="item.auditRemark">
              <span>备注</span>{{ item.auditRemark }}
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
    <van-dialog
      v-model="show"
      show-cancel-button
      close-on-click-overlay
      confirm-button-text="通过"
      title="温馨提示"
      @confirm="confirm(1)"
    >
      <div class="dialog-wrap">
        <div style="text-align: center;">{{ dialogMsg }}</div>
        <div v-if="columns.length > 0">
          <div class="dialog-item-title">选择下一位审批人</div>
          <div class="cell-wrap" @click="showSelectPerson = true">
            {{ pickerItem.deptName || '' }} {{ pickerItem.name || '' }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-popup
      v-model="showSelectPerson"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        title="选择审批人"
        :columns="columns"
        @confirm="handleConfirm"
        ref="picker"
        @cancel="showSelectPerson = false"
        value-key="name"
      />
    </van-popup> -->
      <div class="btn-group">
        <van-row
          :gutter="20"
          class="btn-wrap"
          v-if="type != 'au' && mode != 'notice'"
        >
          <van-col :span="24">
            <van-button round type="info" block @click="clickBack"
              >返回</van-button
            >
          </van-col>
        </van-row>
        <van-row :gutter="20" class="btn-wrap" v-if="type == 'au'">
          <template v-if="data.pickUpState == 0">
            <van-col :span="12">
              <van-button round type="warning" block @click="handleAudit(-1)"
                >拒绝</van-button
              >
            </van-col>
            <van-col :span="12">
              <van-button round type="info" block @click="handleAudit(1)"
                >通过</van-button
              >
            </van-col>
          </template>
          <!-- <template v-else>
          <van-col :span="24">
            <van-button round type="info" block @click="clickBack"
              >返回</van-button
            >
          </van-col>
        </template> -->
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { compare, getDateYMD, timeFormart } from "@/utils";
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      data: {},
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
    type() {
      return this.$route.query.type;
    },
    mode() {
      return this.$route.query.mode || "normal";
    },
  },
  mounted() {
    this.getPickupDetail();
  },
  methods: {
    getDateYMD,
    async getPickupDetail() {
      const { data, code } = await this.$https.pickupDetail({
        pickUpId: this.query.id,
      });
      if (code !== 200) {
        return false;
      }
      data.isShowMobile = false
      this.data = data;
    },
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },
    clickBack() {
      this.$router.go(-1);
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
       
        this.$https.getPickMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol
          

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },
    handleAudit(leaveState) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: leaveState == 1 ? "是否通过？" : "是否拒绝？",
        })
        .then(() => {
          // on confirm
          this.pickupAudit(leaveState);
        })
        .catch(() => {
          // on cancel
          // this.pickupAudit(leaveState)
        });
    },
    async pickupAudit(state) {
      const { code } = await this.$https.pickupAudit({
        userId: this.$store.state.userId,
        leaveState: state,
        id: this.query.id,
      });
      if (code !== 200) {
        this.$toast("审批失败");
        return;
      }
      if (state == 1) {
        this.data.pickUpState = 1;
      } else {
        this.data.pickUpState = -1;
      }
      this.$toast("成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #f4f4f6;
}
.detail {
  padding-bottom: 10rem;
  padding-top: 1px;
}
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;
  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.75rem;
    padding: 1rem 1.25rem;
  }
  .panel {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    margin: 0 1rem;
    padding: 1rem;
    /* align-items: center; */
    img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    .info {
      flex: 1;
      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }
    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }
    .center {
      text-align: center;
    }
    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
}
.cell {
  padding: 0.5rem 0;
  color: #454f63;
  font-size: 0.875rem;

  .headline {
    display: inline-block;
    color: #78849e;
    font-size: 0.75rem;

    margin-right: 1rem;
    width: 4rem;
    text-align: right;
  }
}
.dialog-wrap {
  /* padding: 20px; */
  .wrap {
    padding: 10px;
    display: flex;
    flex-direction: column;
    .title {
      text-align: center;
      margin: 1rem 0;
      color: red;
    }
    .remak {
      outline: none;
      border: none;
      background: #f7f7fa;
      padding: 10px 15px;
      border-radius: 30px;
      margin: 10px 0 20px 0;
    }
  }
}
.btn-group {
  width: 100%;
  margin-top: 2.5rem;
  /* left: 0; */
  .btn-wrap {
    padding: 0 1rem 2rem;
  }
}
.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;
  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    > span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }
    > div {
      .iconfont {
        font-size: 0.75rem;
      }
      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }
  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;
    &:last-child {
      border-bottom: none;
    }
    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }
    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }
    .person-avatar {
      margin-right: 1rem;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }
    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
</style>
